var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(-213.000000, -508.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-Menu-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-icons",
    transform: "translate(214.336364, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Arrow-1",
    transform: "translate(5.000000, 4.000000) rotate(-270.000000) translate(-5.000000, -4.000000) ",
    points: "2.5 -0.615384615 7.5 3.71110577 2.5 8.61538462"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicons);
export default __webpack_public_path__ + "static/media/arrow icons.890932cf.svg";
export { ForwardRef as ReactComponent };